/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CareClubCCMAPIModelsStoredProceduresGetServiceAgreementsMatchingSearchTermResult,
  CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest,
  CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionResult,
  CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionsResult,
  CareClubCCMAPIModelsStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsResult,
  CareClubCCMAPIModelsStoredProceduresSpCardsGetDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest,
  CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest,
  CareClubCCMAPIModelsStoredProceduresSpJobScriptsGetScriptResult,
  CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest,
  CareClubCCMAPIModelsStoredProceduresSpPAFGetAddressesResult,
  CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest,
  CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingResult,
  CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsResult,
  CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsLookupGetJobTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsCancelServiceAgreementResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAccountBalanceResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveEngineersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveUsersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAddressesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAdjustmentPaymentResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAllNotesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAllocatedOffersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAuditActionsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetBillingDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCCJClaimStatusesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCallTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancelReasonsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancellationDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationContextResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationsPendingResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCompaniesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCompletedJobsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetContactResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetContactsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlActionLogsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlCasesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlHoldsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerAgreementsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerAttributesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryEntriesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryEntryResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryOutcomesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiarySummaryResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiscountRepaymentResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetEnquiriesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetEnquiryResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetFeeResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetIncentiveTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetIssuesCoverResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetNoteResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetNotesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentSummaryResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReportLinksResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementDetailResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetStatusResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetTaskQueueResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetTradesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUnprocessedPlanResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUserLocksResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUsersByPermissionResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetVIPDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetValidCampaignCodesResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCreditControlActionLogResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCreditControlResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetNoteResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Result,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeResult,
  CareClubCCMAPIModelsStoredProceduresSpSettingsGetSettingResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeGetCustomerResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetCardResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetEventResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetEventStatusResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetProductResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundResult,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest,
  CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionResult,
  GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermParams,
  GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsParams,
  GetApiStoredProceduresSpCardsGetDetailsParams,
  GetApiStoredProceduresSpJobScriptsGetScriptParams,
  GetApiStoredProceduresSpPAFGetAddressesParams,
  GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsParams,
  GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesParams,
  GetApiStoredProceduresSpServiceAgreementsApplyUserLockParams,
  GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordParams,
  GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementParams,
  GetApiStoredProceduresSpServiceAgreementsChangeStatusParams,
  GetApiStoredProceduresSpServiceAgreementsClearUserLockParams,
  GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobParams,
  GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsParams,
  GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsParams,
  GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceParams,
  GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesParams,
  GetApiStoredProceduresSpServiceAgreementsDeleteJobParams,
  GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceParams,
  GetApiStoredProceduresSpServiceAgreementsGetAddressesParams,
  GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentParams,
  GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksParams,
  GetApiStoredProceduresSpServiceAgreementsGetAllNotesParams,
  GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersParams,
  GetApiStoredProceduresSpServiceAgreementsGetAuditActionsParams,
  GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesParams,
  GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextParams,
  GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotParams,
  GetApiStoredProceduresSpServiceAgreementsGetClaimValidationParams,
  GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingParams,
  GetApiStoredProceduresSpServiceAgreementsGetClaimsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsParams,
  GetApiStoredProceduresSpServiceAgreementsGetContactParams,
  GetApiStoredProceduresSpServiceAgreementsGetContactsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesParams,
  GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesParams,
  GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksParams,
  GetApiStoredProceduresSpServiceAgreementsGetCustomerParams,
  GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesParams,
  GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryParams,
  GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesParams,
  GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryParams,
  GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentParams,
  GetApiStoredProceduresSpServiceAgreementsGetEnquiriesParams,
  GetApiStoredProceduresSpServiceAgreementsGetEnquiryParams,
  GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersParams,
  GetApiStoredProceduresSpServiceAgreementsGetFeeParams,
  GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodParams,
  GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesParams,
  GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverParams,
  GetApiStoredProceduresSpServiceAgreementsGetJobParams,
  GetApiStoredProceduresSpServiceAgreementsGetJobTypesParams,
  GetApiStoredProceduresSpServiceAgreementsGetJobsParams,
  GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeParams,
  GetApiStoredProceduresSpServiceAgreementsGetNoteParams,
  GetApiStoredProceduresSpServiceAgreementsGetNotesParams,
  GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryParams,
  GetApiStoredProceduresSpServiceAgreementsGetPaymentsParams,
  GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceParams,
  GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailParams,
  GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementParams,
  GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesParams,
  GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsParams,
  GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsParams,
  GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesParams,
  GetApiStoredProceduresSpServiceAgreementsGetTaskQueueParams,
  GetApiStoredProceduresSpServiceAgreementsGetTransactionsParams,
  GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanParams,
  GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanParams,
  GetApiStoredProceduresSpServiceAgreementsGetUserLocksParams,
  GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionParams,
  GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesParams,
  GetApiStoredProceduresSpServiceAgreementsRemoveContactParams,
  GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldParams,
  GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsParams,
  GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailParams,
  GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestParams,
  GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailParams,
  GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailParams,
  GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededParams,
  GetApiStoredProceduresSpServiceAgreementsSetActivationReasonParams,
  GetApiStoredProceduresSpServiceAgreementsSetAuditParams,
  GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataParams,
  GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesParams,
  GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogParams,
  GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldParams,
  GetApiStoredProceduresSpServiceAgreementsSetCreditControlParams,
  GetApiStoredProceduresSpServiceAgreementsSetCustomerParams,
  GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerParams,
  GetApiStoredProceduresSpServiceAgreementsSetLoginParams,
  GetApiStoredProceduresSpServiceAgreementsSetNoteParams,
  GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusParams,
  GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsParams,
  GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideParams,
  GetApiStoredProceduresSpServiceAgreementsStopCancellationParams,
  GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferParams,
  GetApiStoredProceduresSpServiceAgreementsUndoCancellationParams,
  GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsParams,
  GetApiStoredProceduresSpSettingsGetSettingParams,
  GetApiStoredProceduresSpStripeGetCustomerParams,
  GetApiStoredProceduresSpStripeSetCardParams,
  GetApiStoredProceduresSpStripeSetEventStatusParams,
  RightioStripeAPIWrapperModelsDtoSubscriptionDto
} from '../../model';

import { customInstance } from '../../../../../services/CCMAccess/index';
import type { ErrorType , BodyType } from '../../../../../services/CCMAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Searches for service agreements matching the specified search term.
 */
export const getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm = (
    params: GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresGetServiceAgreementsMatchingSearchTermResult[]>(
      {url: `/api/StoredProcedures/GetServiceAgreementsMatchingSearchTerm`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryKey = (params: GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermParams,) => {
    return [`/api/StoredProcedures/GetServiceAgreementsMatchingSearchTerm`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>, TError = ErrorType<void>>(params: GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>> = ({ signal }) => getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>>
export type GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryError = ErrorType<void>


/**
 * @summary Searches for service agreements matching the specified search term.
 */

export function useGetApiStoredProceduresGetServiceAgreementsMatchingSearchTerm<TData = Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresGetServiceAgreementsMatchingSearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresGetServiceAgreementsMatchingSearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresGetServiceAgreementsMatchingSearchTermQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of charges for a booking.
 */
export const postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking = (
    careClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingResult>(
      {url: `/api/StoredProcedures/spRF_TrackFast_Jobs_GetCharges_Booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpRFTrackFastJobsGetChargesBookingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpRFTrackFastJobsGetChargesBookingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>>
    export type PostApiStoredProceduresSpRFTrackFastJobsGetChargesBookingMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>
    export type PostApiStoredProceduresSpRFTrackFastJobsGetChargesBookingMutationError = ErrorType<void>

    /**
 * @summary Gets a list of charges for a booking.
 */
export const usePostApiStoredProceduresSpRFTrackFastJobsGetChargesBooking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpRFTrackFastJobsGetChargesBooking>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsGetChargesBookingRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpRFTrackFastJobsGetChargesBookingMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets a list of job groups based on a trade code.
 */
export const getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups = (
    params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsResult[]>(
      {url: `/api/StoredProcedures/spRF_TrackFast_Jobs_Lookup_GetJobGroups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryKey = (params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsParams,) => {
    return [`/api/StoredProcedures/spRF_TrackFast_Jobs_Lookup_GetJobGroups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>> = ({ signal }) => getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>>
export type GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryError = ErrorType<void>


/**
 * @summary Gets a list of job groups based on a trade code.
 */

export function useGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of job types based on an account code, trade code, and optional job group code and postcode.
 */
export const getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes = (
    params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpRFTrackFastJobsLookupGetJobTypesResult[]>(
      {url: `/api/StoredProcedures/spRF_TrackFast_Jobs_Lookup_GetJobTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryKey = (params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesParams,) => {
    return [`/api/StoredProcedures/spRF_TrackFast_Jobs_Lookup_GetJobTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>> = ({ signal }) => getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>>
export type GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of job types based on an account code, trade code, and optional job group code and postcode.
 */

export function useGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpRFTrackFastJobsLookupGetJobTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get booking restriction based on the postcode area, trade, account, call type, job type and date
 * @summary Get booking restriction for a set of parameters
 */
export const storedProceduresBookingGetBookingRestriction = (
    careClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionResult[]>(
      {url: `/api/StoredProcedures/sp_Booking_GetBookingRestriction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest, signal
    },
      options);
    }
  


export const getStoredProceduresBookingGetBookingRestrictionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>}, TContext> => {

const mutationKey = ['storedProceduresBookingGetBookingRestriction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  storedProceduresBookingGetBookingRestriction(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StoredProceduresBookingGetBookingRestrictionMutationResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>>
    export type StoredProceduresBookingGetBookingRestrictionMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>
    export type StoredProceduresBookingGetBookingRestrictionMutationError = ErrorType<unknown>

    /**
 * @summary Get booking restriction for a set of parameters
 */
export const useStoredProceduresBookingGetBookingRestriction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionRequest>},
        TContext
      > => {

      const mutationOptions = getStoredProceduresBookingGetBookingRestrictionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Get all booking restrictions
 * @summary Get all booking restrictions
 */
export const storedProceduresBookingGetBookingRestrictions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpBookingGetBookingRestrictionsResult[]>(
      {url: `/api/StoredProcedures/sp_Booking_GetBookingRestrictions`, method: 'GET', signal
    },
      options);
    }
  

export const getStoredProceduresBookingGetBookingRestrictionsQueryKey = () => {
    return [`/api/StoredProcedures/sp_Booking_GetBookingRestrictions`] as const;
    }

    
export const getStoredProceduresBookingGetBookingRestrictionsQueryOptions = <TData = Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoredProceduresBookingGetBookingRestrictionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>> = ({ signal }) => storedProceduresBookingGetBookingRestrictions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>, TError, TData> & { queryKey: QueryKey }
}

export type StoredProceduresBookingGetBookingRestrictionsQueryResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>>
export type StoredProceduresBookingGetBookingRestrictionsQueryError = ErrorType<unknown>


/**
 * @summary Get all booking restrictions
 */

export function useStoredProceduresBookingGetBookingRestrictions<TData = Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStoredProceduresBookingGetBookingRestrictionsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves all the basic plan costs for all combinations of service agreement type, duration, billing frequency and excess.
 */
export const getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations = (
    params: GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsResult>(
      {url: `/api/StoredProcedures/sp_Call_ServiceAgreements_GetBasicPlanCostForAllCombinations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryKey = (params: GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsParams,) => {
    return [`/api/StoredProcedures/sp_Call_ServiceAgreements_GetBasicPlanCostForAllCombinations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>> = ({ signal }) => getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>>
export type GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryError = ErrorType<void>


/**
 * @summary Retrieves all the basic plan costs for all combinations of service agreement type, duration, billing frequency and excess.
 */

export function useGetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets details of a card based on its number
 */
export const getApiStoredProceduresSpCardsGetDetails = (
    params: GetApiStoredProceduresSpCardsGetDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpCardsGetDetailsResult>(
      {url: `/api/StoredProcedures/sp_Cards_GetDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpCardsGetDetailsQueryKey = (params: GetApiStoredProceduresSpCardsGetDetailsParams,) => {
    return [`/api/StoredProcedures/sp_Cards_GetDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpCardsGetDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpCardsGetDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpCardsGetDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>> = ({ signal }) => getApiStoredProceduresSpCardsGetDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpCardsGetDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>>
export type GetApiStoredProceduresSpCardsGetDetailsQueryError = ErrorType<void>


/**
 * @summary Gets details of a card based on its number
 */

export function useGetApiStoredProceduresSpCardsGetDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpCardsGetDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpCardsGetDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpCardsGetDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends an error to a developer via email
 */
export const postApiStoredProceduresSpEmailSendErrorToDeveloper = (
    careClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_Email_SendErrorToDeveloper`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpEmailSendErrorToDeveloperMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpEmailSendErrorToDeveloper'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpEmailSendErrorToDeveloper(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpEmailSendErrorToDeveloperMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>>
    export type PostApiStoredProceduresSpEmailSendErrorToDeveloperMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>
    export type PostApiStoredProceduresSpEmailSendErrorToDeveloperMutationError = ErrorType<void>

    /**
 * @summary Sends an error to a developer via email
 */
export const usePostApiStoredProceduresSpEmailSendErrorToDeveloper = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpEmailSendErrorToDeveloper>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpEmailSendErrorToDeveloperRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpEmailSendErrorToDeveloperMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the GoCardless details for a service agreement
 */
export const postApiStoredProceduresSpGoCardlessSetServiceAgreement = (
    careClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_GoCardless_SetServiceAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpGoCardlessSetServiceAgreementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpGoCardlessSetServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpGoCardlessSetServiceAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpGoCardlessSetServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>>
    export type PostApiStoredProceduresSpGoCardlessSetServiceAgreementMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>
    export type PostApiStoredProceduresSpGoCardlessSetServiceAgreementMutationError = ErrorType<void>

    /**
 * @summary Sets the GoCardless details for a service agreement
 */
export const usePostApiStoredProceduresSpGoCardlessSetServiceAgreement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpGoCardlessSetServiceAgreement>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpGoCardlessSetServiceAgreementRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpGoCardlessSetServiceAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary HTTP GET method for the stored procedure sp_JobScripts_GetScript
 */
export const getApiStoredProceduresSpJobScriptsGetScript = (
    params?: GetApiStoredProceduresSpJobScriptsGetScriptParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpJobScriptsGetScriptResult>(
      {url: `/api/StoredProcedures/sp_JobScripts_GetScript`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpJobScriptsGetScriptQueryKey = (params?: GetApiStoredProceduresSpJobScriptsGetScriptParams,) => {
    return [`/api/StoredProcedures/sp_JobScripts_GetScript`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpJobScriptsGetScriptQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpJobScriptsGetScriptParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpJobScriptsGetScriptQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>> = ({ signal }) => getApiStoredProceduresSpJobScriptsGetScript(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpJobScriptsGetScriptQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>>
export type GetApiStoredProceduresSpJobScriptsGetScriptQueryError = ErrorType<void>


/**
 * @summary HTTP GET method for the stored procedure sp_JobScripts_GetScript
 */

export function useGetApiStoredProceduresSpJobScriptsGetScript<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpJobScriptsGetScriptParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpJobScriptsGetScript>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpJobScriptsGetScriptQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Executes the stored procedure to set a job from the website
 */
export const postApiStoredProceduresSpJobsWebsiteSetJob = (
    careClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_Jobs_Website_SetJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpJobsWebsiteSetJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpJobsWebsiteSetJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpJobsWebsiteSetJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpJobsWebsiteSetJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>>
    export type PostApiStoredProceduresSpJobsWebsiteSetJobMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>
    export type PostApiStoredProceduresSpJobsWebsiteSetJobMutationError = ErrorType<void>

    /**
 * @summary Executes the stored procedure to set a job from the website
 */
export const usePostApiStoredProceduresSpJobsWebsiteSetJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpJobsWebsiteSetJob>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpJobsWebsiteSetJobRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpJobsWebsiteSetJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets a list of addresses based on a postcode and optional property and extended details parameters.
 */
export const getApiStoredProceduresSpPAFGetAddresses = (
    params: GetApiStoredProceduresSpPAFGetAddressesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpPAFGetAddressesResult[]>(
      {url: `/api/StoredProcedures/sp_PAF_GetAddresses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpPAFGetAddressesQueryKey = (params: GetApiStoredProceduresSpPAFGetAddressesParams,) => {
    return [`/api/StoredProcedures/sp_PAF_GetAddresses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpPAFGetAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpPAFGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpPAFGetAddressesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>> = ({ signal }) => getApiStoredProceduresSpPAFGetAddresses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpPAFGetAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>>
export type GetApiStoredProceduresSpPAFGetAddressesQueryError = ErrorType<void>


/**
 * @summary Gets a list of addresses based on a postcode and optional property and extended details parameters.
 */

export function useGetApiStoredProceduresSpPAFGetAddresses<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpPAFGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpPAFGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpPAFGetAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the VIP details for a customer based on the service agreement customer ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetVIPDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetVIPDetailsResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetVIPDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetVIPDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetVIPDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryError = ErrorType<void>


/**
 * @summary Gets the VIP details for a customer based on the service agreement customer ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetVIPDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetVIPDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetVIPDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Allocates a subscription offer to a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_AllocateSubscriptionOffer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>>
    export type PostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>
    export type PostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferMutationError = ErrorType<void>

    /**
 * @summary Allocates a subscription offer to a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOffer>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsAllocateSubscriptionOfferMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Applies a user lock to a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsApplyUserLock = (
    params: GetApiStoredProceduresSpServiceAgreementsApplyUserLockParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ApplyUserLock`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsApplyUserLockParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_ApplyUserLock`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsApplyUserLockParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsApplyUserLock(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>>
export type GetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryError = ErrorType<void>


/**
 * @summary Applies a user lock to a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsApplyUserLock<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsApplyUserLockParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsApplyUserLock>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsApplyUserLockQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Books a job for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsBookJob = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_BookJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsBookJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsBookJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsBookJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsBookJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>>
    export type PostApiStoredProceduresSpServiceAgreementsBookJobMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>
    export type PostApiStoredProceduresSpServiceAgreementsBookJobMutationError = ErrorType<void>

    /**
 * @summary Books a job for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsBookJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsBookJob>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsBookJobRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsBookJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Cancels a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement = (
    params: GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsCancelServiceAgreementResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CancelServiceAgreement`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CancelServiceAgreement`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>>
export type GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryError = ErrorType<void>


/**
 * @summary Cancels a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCancelServiceAgreement<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCancelServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCancelServiceAgreementQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends a password reset email to the specified email address.
 */
export const getApiStoredProceduresSpServiceAgreementsCCHForgotPassword = (
    params: GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CCH_ForgotPassword`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CCH_ForgotPassword`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCCHForgotPassword(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>>
export type GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryError = ErrorType<void>


/**
 * @summary Sends a password reset email to the specified email address.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCCHForgotPassword<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCCHForgotPassword>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCCHForgotPasswordQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Changes the status of a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsChangeStatus = (
    params: GetApiStoredProceduresSpServiceAgreementsChangeStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ChangeStatus`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsChangeStatusQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsChangeStatusParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_ChangeStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsChangeStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsChangeStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsChangeStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsChangeStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsChangeStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>>
export type GetApiStoredProceduresSpServiceAgreementsChangeStatusQueryError = ErrorType<void>


/**
 * @summary Changes the status of a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsChangeStatus<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsChangeStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsChangeStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsChangeStatusQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Clears a user lock from a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsClearUserLock = (
    params: GetApiStoredProceduresSpServiceAgreementsClearUserLockParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ClearUserLock`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsClearUserLockQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsClearUserLockParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_ClearUserLock`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsClearUserLockQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsClearUserLockParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsClearUserLockQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsClearUserLock(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsClearUserLockQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>>
export type GetApiStoredProceduresSpServiceAgreementsClearUserLockQueryError = ErrorType<void>


/**
 * @summary Clears a user lock from a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsClearUserLock<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsClearUserLockParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsClearUserLock>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsClearUserLockQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Clones validation information from a service agreement job to a linked job.
 */
export const getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob = (
    params: GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CloneValidationToLinkedJob`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CloneValidationToLinkedJob`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>>
export type GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryError = ErrorType<void>


/**
 * @summary Clones validation information from a service agreement job to a linked job.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCloneValidationToLinkedJobQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Copies GoCardless details from a service agreement customer to all of their service agreements.
 */
export const getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements = (
    params: GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CopyGoCardlessDetailsToAllCustomerAgreements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CopyGoCardlessDetailsToAllCustomerAgreements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>>
export type GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryError = ErrorType<void>


/**
 * @summary Copies GoCardless details from a service agreement customer to all of their service agreements.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCopyGoCardlessDetailsToAllCustomerAgreementsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Copies Stripe details from a service agreement customer to all of their service agreements.
 */
export const getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements = (
    params: GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CopyStripeDetailsToAllCustomerAgreements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CopyStripeDetailsToAllCustomerAgreements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>>
export type GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryError = ErrorType<void>


/**
 * @summary Copies Stripe details from a service agreement customer to all of their service agreements.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCopyStripeDetailsToAllCustomerAgreementsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Creates an excess invoice for a service agreement job.
 */
export const getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice = (
    params: GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CreateExcessInvoice`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CreateExcessInvoice`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>>
export type GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryError = ErrorType<void>


/**
 * @summary Creates an excess invoice for a service agreement job.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCreateExcessInvoice<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreateExcessInvoice>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCreateExcessInvoiceQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Credits an off amount against outstanding invoices for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices = (
    params: GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_CreditOffOutstandingInvoices`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_CreditOffOutstandingInvoices`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>>
export type GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryError = ErrorType<void>


/**
 * @summary Credits an off amount against outstanding invoices for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoices>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsCreditOffOutstandingInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Deletes a service agreement job.
 */
export const getApiStoredProceduresSpServiceAgreementsDeleteJob = (
    params: GetApiStoredProceduresSpServiceAgreementsDeleteJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_DeleteJob`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsDeleteJobQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsDeleteJobParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_DeleteJob`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsDeleteJobQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsDeleteJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsDeleteJobQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsDeleteJob(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsDeleteJobQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>>
export type GetApiStoredProceduresSpServiceAgreementsDeleteJobQueryError = ErrorType<void>


/**
 * @summary Deletes a service agreement job.
 */

export function useGetApiStoredProceduresSpServiceAgreementsDeleteJob<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsDeleteJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsDeleteJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsDeleteJobQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends a payment confirmation email for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_EmailPaymentConfirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>>
    export type PostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmationMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>
    export type PostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmationMutationError = ErrorType<void>

    /**
 * @summary Sends a payment confirmation email for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmation>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsEmailPaymentConfirmationRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsEmailPaymentConfirmationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets the account balance for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAccountBalance = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAccountBalanceResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAccountBalance`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAccountBalance`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAccountBalance(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryError = ErrorType<void>


/**
 * @summary Gets the account balance for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAccountBalance<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAccountBalanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAccountBalance>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAccountBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of active engineers.
 */
export const getApiStoredProceduresSpServiceAgreementsGetActiveEngineers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveEngineersResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetActiveEngineers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetActiveEngineers`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetActiveEngineers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>>
export type GetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryError = ErrorType<void>


/**
 * @summary Gets a list of active engineers.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetActiveEngineers<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetActiveEngineersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of active users from the database.
 */
export const getApiStoredProceduresSpServiceAgreementsGetActiveUsers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveUsersResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetActiveUsers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetActiveUsers`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetActiveUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>>
export type GetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryError = ErrorType<void>


/**
 * @summary Gets a list of active users from the database.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetActiveUsers<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetActiveUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetActiveUsersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of addresses for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAddresses = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAddressesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAddressesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAddresses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAddressesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAddressesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAddresses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAddressesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAddresses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAddressesQueryError = ErrorType<void>


/**
 * @summary Gets a list of addresses for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAddresses<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets an adjustment payment for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAdjustmentPaymentResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAdjustmentPayment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAdjustmentPayment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryError = ErrorType<void>


/**
 * @summary Gets an adjustment payment for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAdjustmentPayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAdjustmentPaymentQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of agreement history links for a given user.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAgreementHistoryLinks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAgreementHistoryLinks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryError = ErrorType<void>


/**
 * @summary Gets a list of agreement history links for a given user.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAgreementHistoryLinksQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets all notes for a given service agreement customer.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAllNotes = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAllNotesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAllNotesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAllNotes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAllNotesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAllNotes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAllNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAllNotes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryError = ErrorType<void>


/**
 * @summary Gets all notes for a given service agreement customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAllNotes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAllNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAllNotesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of allocated offers for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAllocatedOffersResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAllocatedOffers`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAllocatedOffers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryError = ErrorType<void>


/**
 * @summary Gets a list of allocated offers for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAllocatedOffers<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAllocatedOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAllocatedOffersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of appointment time types.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAppointmentTimeTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAppointmentTimeTypes`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of appointment time types.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAppointmentTimeTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of audit actions for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetAuditActions = (
    params: GetApiStoredProceduresSpServiceAgreementsGetAuditActionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAuditActionsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAuditActions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetAuditActionsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetAuditActions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetAuditActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetAuditActions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>>
export type GetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryError = ErrorType<void>


/**
 * @summary Gets a list of audit actions for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetAuditActions<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetAuditActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetAuditActions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetAuditActionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of available offers based on the given request parameters.
 */
export const postApiStoredProceduresSpServiceAgreementsGetAvailableOffers = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetAvailableOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsGetAvailableOffersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsGetAvailableOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsGetAvailableOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsGetAvailableOffersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>>
    export type PostApiStoredProceduresSpServiceAgreementsGetAvailableOffersMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>
    export type PostApiStoredProceduresSpServiceAgreementsGetAvailableOffersMutationError = ErrorType<void>

    /**
 * @summary Gets a list of available offers based on the given request parameters.
 */
export const usePostApiStoredProceduresSpServiceAgreementsGetAvailableOffers = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetAvailableOffers>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetAvailableOffersRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsGetAvailableOffersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets billing details for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetBillingDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetBillingDetailsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetBillingDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetBillingDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetBillingDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryError = ErrorType<void>


/**
 * @summary Gets billing details for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetBillingDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetBillingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetBillingDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetBillingDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of call types.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCallTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCallTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCallTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCallTypes`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCallTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of call types.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCallTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCallTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCallTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets cancellation details for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCancellationDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancellationDetailsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCancellationDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCancellationDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCancellationDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryError = ErrorType<void>


/**
 * @summary Gets cancellation details for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCancellationDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancellationDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCancellationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets data items for a given cancellation reason.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCancelReasonDataItems`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCancelReasonDataItems`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryError = ErrorType<void>


/**
 * @summary Gets data items for a given cancellation reason.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItems>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonDataItemsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of cancellation reasons, optionally filtered by parent ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCancelReasons = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCancelReasonsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCancelReasons`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCancelReasons`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCancelReasons(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryError = ErrorType<void>


/**
 * @summary Gets a list of cancellation reasons, optionally filtered by parent ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCancelReasons<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetCancelReasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCancelReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCancelReasonsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of County Court Judgment (CCJ) claim statuses for a given credit control.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCCJClaimStatusesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCCJClaimStatuses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCCJClaimStatuses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryError = ErrorType<void>


/**
 * @summary Gets a list of County Court Judgment (CCJ) claim statuses for a given credit control.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCCJClaimStatuses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCCJClaimStatusesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of claims for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetClaims = (
    params: GetApiStoredProceduresSpServiceAgreementsGetClaimsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetClaims`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetClaimsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetClaimsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetClaims`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetClaimsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetClaimsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetClaims(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>>
export type GetApiStoredProceduresSpServiceAgreementsGetClaimsQueryError = ErrorType<void>


/**
 * @summary Gets a list of claims for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetClaims<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaims>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetClaimsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the claim validation context for a given service agreement and job.
 */
export const getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext = (
    params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationContextResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationContext`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationContext`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>>
export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryError = ErrorType<void>


/**
 * @summary Gets the claim validation context for a given service agreement and job.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContext<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a snapshot of the claim validation context for a given claim validation.
 */
export const getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot = (
    params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationContextSnapshot`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationContextSnapshot`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>>
export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryError = ErrorType<void>


/**
 * @summary Gets a snapshot of the claim validation context for a given claim validation.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshot>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationContextSnapshotQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the claim validation for a given job.
 */
export const getApiStoredProceduresSpServiceAgreementsGetClaimValidation = (
    params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidation`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidation`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetClaimValidation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>>
export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryError = ErrorType<void>


/**
 * @summary Gets the claim validation for a given job.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetClaimValidation<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of pending claim validations for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending = (
    params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetClaimValidationsPendingResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationsPending`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetClaimValidationsPending`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>>
export type GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryError = ErrorType<void>


/**
 * @summary Gets a list of pending claim validations for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetClaimValidationsPending>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetClaimValidationsPendingQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of companies.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCompanies = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCompaniesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCompanies`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCompanies`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryError = ErrorType<void>


/**
 * @summary Gets a list of companies.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCompanies<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompanies>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCompaniesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of completed jobs for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCompletedJobs = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCompletedJobsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCompletedJobs`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCompletedJobs`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCompletedJobs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryError = ErrorType<void>


/**
 * @summary Gets a list of completed jobs for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCompletedJobs<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCompletedJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCompletedJobs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCompletedJobsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a contact by ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetContact = (
    params: GetApiStoredProceduresSpServiceAgreementsGetContactParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetContactResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetContact`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetContactQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetContactParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetContact`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetContactQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetContactQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetContact(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetContactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>>
export type GetApiStoredProceduresSpServiceAgreementsGetContactQueryError = ErrorType<void>


/**
 * @summary Gets a contact by ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetContact<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetContactQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of contacts for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetContacts = (
    params: GetApiStoredProceduresSpServiceAgreementsGetContactsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetContactsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetContacts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetContactsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetContactsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetContacts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetContactsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetContactsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetContacts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>>
export type GetApiStoredProceduresSpServiceAgreementsGetContactsQueryError = ErrorType<void>


/**
 * @summary Gets a list of contacts for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetContacts<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetContacts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetContactsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of credit control action logs for a given credit control action.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlActionLogsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlActionLogs`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlActionLogs`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryError = ErrorType<void>


/**
 * @summary Gets a list of credit control action logs for a given credit control action.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCreditControlActionLogsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of credit control cases for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCreditControlCases = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlCasesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlCases`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlCases`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCreditControlCases(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryError = ErrorType<void>


/**
 * @summary Gets a list of credit control cases for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCreditControlCases<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlCases>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCreditControlCasesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of credit control holds.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCreditControlHoldsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlHolds`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCreditControlHolds`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryError = ErrorType<void>


/**
 * @summary Gets a list of credit control holds.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCreditControlHolds<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCreditControlHolds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCreditControlHoldsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of service agreements for a given customer.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerAgreementsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCustomerAgreements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCustomerAgreements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryError = ErrorType<void>


/**
 * @summary Gets a list of service agreements for a given customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCustomerAgreements<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCustomerAgreementsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of customer attributes for a given service agreement customer.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerAttributesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCustomerAttributes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCustomerAttributes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryError = ErrorType<void>


/**
 * @summary Gets a list of customer attributes for a given service agreement customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCustomerAttributes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerAttributes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCustomerAttributesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the customer for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCustomer = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCustomerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCustomer`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCustomerParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCustomer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCustomer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCustomerQueryError = ErrorType<void>


/**
 * @summary Gets the customer for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCustomer<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the details of a given customer.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCustomerDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerDetailsResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCustomerDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCustomerDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCustomerDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryError = ErrorType<void>


/**
 * @summary Gets the details of a given customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCustomerDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCustomerDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of customer history links for a given user.
 */
export const getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks = (
    params: GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetCustomerHistoryLinks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetCustomerHistoryLinks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>>
export type GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryError = ErrorType<void>


/**
 * @summary Gets a list of customer history links for a given user.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetCustomerHistoryLinksQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of diary entries for a given service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiaryEntries = (
    params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryEntriesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiaryEntries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiaryEntries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiaryEntries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryError = ErrorType<void>


/**
 * @summary Gets a list of diary entries for a given service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiaryEntries<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a specific diary entry.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiaryEntry = (
    params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryEntryResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiaryEntry`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiaryEntry`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiaryEntry(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryError = ErrorType<void>


/**
 * @summary Gets a specific diary entry.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiaryEntry<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetDiaryEntryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryEntry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiaryEntryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of diary outcomes, optionally filtered by a diary category.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiaryOutcomesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiaryOutcomes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiaryOutcomes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryError = ErrorType<void>


/**
 * @summary Gets a list of diary outcomes, optionally filtered by a diary category.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiaryOutcomes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiaryOutcomesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a summary of diary entries for a given date.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiarySummary = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiarySummaryResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiarySummary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiarySummary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiarySummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryError = ErrorType<void>


/**
 * @summary Gets a summary of diary entries for a given date.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiarySummary<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a summary of outstanding diary entries.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiarySummary_Outstanding`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiarySummary_Outstanding`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryError = ErrorType<void>


/**
 * @summary Gets a summary of outstanding diary entries.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstanding>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiarySummaryOutstandingQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the discount repayment amount for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment = (
    params: GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetDiscountRepaymentResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetDiscountRepayment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetDiscountRepayment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>>
export type GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryError = ErrorType<void>


/**
 * @summary Gets the discount repayment amount for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetDiscountRepayment<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetDiscountRepayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetDiscountRepaymentQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of enquiries for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetEnquiries = (
    params: GetApiStoredProceduresSpServiceAgreementsGetEnquiriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetEnquiriesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetEnquiries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetEnquiriesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetEnquiries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetEnquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetEnquiries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>>
export type GetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryError = ErrorType<void>


/**
 * @summary Gets a list of enquiries for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetEnquiries<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetEnquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetEnquiriesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets an enquiry for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetEnquiry = (
    params: GetApiStoredProceduresSpServiceAgreementsGetEnquiryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetEnquiryResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetEnquiry`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetEnquiryParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetEnquiry`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetEnquiryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetEnquiry(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>>
export type GetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryError = ErrorType<void>


/**
 * @summary Gets an enquiry for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetEnquiry<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetEnquiryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetEnquiry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetEnquiryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the details of an external engineer.
 */
export const getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetExternalEngineerDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetExternalEngineerDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryError = ErrorType<void>


/**
 * @summary Gets the details of an external engineer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of external engineers based on a postcode and trade code.
 */
export const getApiStoredProceduresSpServiceAgreementsGetExternalEngineers = (
    params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetExternalEngineers`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetExternalEngineers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetExternalEngineers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>>
export type GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryError = ErrorType<void>


/**
 * @summary Gets a list of external engineers based on a postcode and trade code.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetExternalEngineers<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetExternalEngineersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetExternalEngineersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a fee based on a service agreement type and start date.
 */
export const getApiStoredProceduresSpServiceAgreementsGetFee = (
    params: GetApiStoredProceduresSpServiceAgreementsGetFeeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetFeeResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetFee`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetFeeQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetFeeParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetFee`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetFeeQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetFeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetFeeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetFee(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetFeeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>>
export type GetApiStoredProceduresSpServiceAgreementsGetFeeQueryError = ErrorType<void>


/**
 * @summary Gets a fee based on a service agreement type and start date.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetFee<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetFeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetFee>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetFeeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the amount of inactive invoices for a given service agreement and payment period.
 */
export const getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod = (
    params: GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetInactiveInvoiceAmountByPaymentPeriod`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetInactiveInvoiceAmountByPaymentPeriod`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>>
export type GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryError = ErrorType<void>


/**
 * @summary Gets the amount of inactive invoices for a given service agreement and payment period.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriod>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetInactiveInvoiceAmountByPaymentPeriodQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of incentive types based on an optional service agreement type ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetIncentiveTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetIncentiveTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetIncentiveTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of incentive types based on an optional service agreement type ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetIncentiveTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIncentiveTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetIncentiveTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the issues cover for a given service agreement ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetIssuesCover = (
    params: GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetIssuesCoverResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetIssuesCover`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetIssuesCover`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetIssuesCover(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>>
export type GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryError = ErrorType<void>


/**
 * @summary Gets the issues cover for a given service agreement ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetIssuesCover<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetIssuesCoverParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetIssuesCover>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetIssuesCoverQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a job for a given service agreement job ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetJob = (
    params: GetApiStoredProceduresSpServiceAgreementsGetJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetJob`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetJobQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetJobParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetJob`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetJobQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetJob(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>>
export type GetApiStoredProceduresSpServiceAgreementsGetJobQueryError = ErrorType<void>


/**
 * @summary Gets a job for a given service agreement job ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetJob<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetJobQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of jobs for a given service agreement
 */
export const getApiStoredProceduresSpServiceAgreementsGetJobs = (
    params: GetApiStoredProceduresSpServiceAgreementsGetJobsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetJobs`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetJobsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetJobsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetJobs`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetJobsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetJobs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>>
export type GetApiStoredProceduresSpServiceAgreementsGetJobsQueryError = ErrorType<void>


/**
 * @summary Gets a list of jobs for a given service agreement
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetJobs<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetJobsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of job types based on an optional where clause.
 */
export const getApiStoredProceduresSpServiceAgreementsGetJobTypes = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetJobTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetJobTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetJobTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetJobTypesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetJobTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetJobTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of job types based on an optional where clause.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetJobTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetJobTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the latest audit entries for a service agreement by type
 */
export const getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType = (
    params: GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetLatestAuditEntriesByType`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetLatestAuditEntriesByType`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>>
export type GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryError = ErrorType<void>


/**
 * @summary Gets the latest audit entries for a service agreement by type
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByType>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a note by ID
 */
export const getApiStoredProceduresSpServiceAgreementsGetNote = (
    params: GetApiStoredProceduresSpServiceAgreementsGetNoteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetNoteResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetNote`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetNoteQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetNoteParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetNote`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetNoteQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetNoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetNoteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetNote(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>>
export type GetApiStoredProceduresSpServiceAgreementsGetNoteQueryError = ErrorType<void>


/**
 * @summary Gets a note by ID
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetNote<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetNoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNote>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetNoteQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of notes for a specific service agreement
 */
export const getApiStoredProceduresSpServiceAgreementsGetNotes = (
    params: GetApiStoredProceduresSpServiceAgreementsGetNotesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetNotesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetNotes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetNotesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetNotesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetNotes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetNotesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetNotes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetNotesQueryError = ErrorType<void>


/**
 * @summary Gets a list of notes for a specific service agreement
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetNotes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetNotesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the payment details for a service agreement
 */
export const getApiStoredProceduresSpServiceAgreementsGetPaymentDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentDetailsResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetPaymentDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetPaymentDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetPaymentDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryError = ErrorType<void>


/**
 * @summary Gets the payment details for a service agreement
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetPaymentDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetPaymentDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of payments for the specified service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetPayments = (
    params: GetApiStoredProceduresSpServiceAgreementsGetPaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetPayments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetPaymentsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetPayments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetPayments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>>
export type GetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of payments for the specified service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetPayments<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPayments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a payment summary for the specified service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetPaymentSummary = (
    params: GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPaymentSummaryResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetPaymentSummary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetPaymentSummary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetPaymentSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>>
export type GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryError = ErrorType<void>


/**
 * @summary Retrieves a payment summary for the specified service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetPaymentSummary<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetPaymentSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetPaymentSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves the cost of a plan after applying offers.
 */
export const postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetPlanCostAfterOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>>
    export type PostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>
    export type PostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersMutationError = ErrorType<void>

    /**
 * @summary Retrieves the cost of a plan after applying offers.
 */
export const usePostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffers>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsGetPlanCostAfterOffersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Retrieves reference data for the specified service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsGetReferenceData = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetReferenceData`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsGetReferenceDataMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsGetReferenceData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsGetReferenceData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsGetReferenceDataMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>>
    export type PostApiStoredProceduresSpServiceAgreementsGetReferenceDataMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>
    export type PostApiStoredProceduresSpServiceAgreementsGetReferenceDataMutationError = ErrorType<void>

    /**
 * @summary Retrieves reference data for the specified service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsGetReferenceData = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsGetReferenceData>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsGetReferenceDataMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Retrieves a list of report links.
 */
export const getApiStoredProceduresSpServiceAgreementsGetReportLinks = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReportLinksResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetReportLinks`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetReportLinks`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetReportLinks(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>>
export type GetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of report links.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetReportLinks<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetReportLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetReportLinksQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a service agreement by reference.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference = (
    params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementByReference`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementByReference`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryError = ErrorType<void>


/**
 * @summary Retrieves a service agreement by reference.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReference>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementByReferenceQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a service agreement by ID.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreement = (
    params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreement`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreement`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreement(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryError = ErrorType<void>


/**
 * @summary Retrieves a service agreement by ID.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreement<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves detailed information for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail = (
    params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementDetailResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementDetail`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementDetail`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryError = ErrorType<void>


/**
 * @summary Retrieves detailed information for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementDetailQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of job types for service agreements.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementJobTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementJobTypes`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of job types for service agreements.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementJobTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of service agreements matching the specified search term.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreements = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of service agreements matching the specified search term.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreements<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of service agreement types.
 */
export const getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetServiceAgreementTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetServiceAgreementTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of service agreement types.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetServiceAgreementTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves the status of the service agreements system.
 */
export const getApiStoredProceduresSpServiceAgreementsGetStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetStatusResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetStatus`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetStatusQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetStatus`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>>
export type GetApiStoredProceduresSpServiceAgreementsGetStatusQueryError = ErrorType<void>


/**
 * @summary Retrieves the status of the service agreements system.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetStatus<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of subscription invoice adjustments for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments = (
    params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetSubscriptionInvoiceAdjustments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetSubscriptionInvoiceAdjustments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>>
export type GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of subscription invoice adjustments for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoiceAdjustmentsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of subscription invoices for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices = (
    params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetSubscriptionInvoices`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetSubscriptionInvoices`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>>
export type GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of subscription invoices for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoices>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetSubscriptionInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a task queue item.
 */
export const getApiStoredProceduresSpServiceAgreementsGetTaskQueue = (
    params: GetApiStoredProceduresSpServiceAgreementsGetTaskQueueParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetTaskQueueResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetTaskQueue`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetTaskQueueParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetTaskQueue`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetTaskQueueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetTaskQueue(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>>
export type GetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryError = ErrorType<void>


/**
 * @summary Retrieves a task queue item.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetTaskQueue<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetTaskQueueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTaskQueue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetTaskQueueQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of trades.
 */
export const getApiStoredProceduresSpServiceAgreementsGetTrades = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetTradesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetTrades`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetTradesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetTrades`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetTradesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetTradesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetTrades(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetTradesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>>
export type GetApiStoredProceduresSpServiceAgreementsGetTradesQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of trades.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetTrades<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTrades>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetTradesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of trades.
 */
export const getApiStoredProceduresSpServiceAgreementsGetTransactions = (
    params: GetApiStoredProceduresSpServiceAgreementsGetTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetTradesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetTransactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetTransactionsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetTransactions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>>
export type GetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of trades.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetTransactions<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetTransactions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves the unprocessed plan for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan = (
    params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUnprocessedPlanResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetUnprocessedPlan`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetUnprocessedPlan`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>>
export type GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryError = ErrorType<void>


/**
 * @summary Retrieves the unprocessed plan for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedPlan>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedPlanQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves the unprocessed Stripe plan for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan = (
    params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetUnprocessedStripePlan`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetUnprocessedStripePlan`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>>
export type GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryError = ErrorType<void>


/**
 * @summary Retrieves the unprocessed Stripe plan for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlan>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetUnprocessedStripePlanQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of user locks for a user.
 */
export const getApiStoredProceduresSpServiceAgreementsGetUserLocks = (
    params: GetApiStoredProceduresSpServiceAgreementsGetUserLocksParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUserLocksResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetUserLocks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetUserLocksParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetUserLocks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetUserLocksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetUserLocks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>>
export type GetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of user locks for a user.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetUserLocks<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetUserLocksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUserLocks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetUserLocksQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of users with a specific permission.
 */
export const getApiStoredProceduresSpServiceAgreementsGetUsersByPermission = (
    params: GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUsersByPermissionResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetUsersByPermission`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetUsersByPermission`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetUsersByPermission(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>>
export type GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of users with a specific permission.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetUsersByPermission<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetUsersByPermission>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetUsersByPermissionQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets valid campaign codes for a service agreements.
 */
export const getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetValidCampaignCodesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetValidCampaignCodes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryKey = () => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetValidCampaignCodes`] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryError = ErrorType<void>


/**
 * @summary Gets valid campaign codes for a service agreements.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetValidCampaignCodesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retrieves a list of VIP override status types.
 */
export const getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes = (
    params?: GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_GetVIPOverrideStatusTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryKey = (params?: GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_GetVIPOverrideStatusTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>>
export type GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of VIP override status types.
 */

export function useGetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsGetVIPOverrideStatusTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Previews a subscription offer.
 */
export const postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferResult[]>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_PreviewSubscriptionOffer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>>
    export type PostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>
    export type PostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferMutationError = ErrorType<void>

    /**
 * @summary Previews a subscription offer.
 */
export const usePostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOffer>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Removes a contact from a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsRemoveContact = (
    params: GetApiStoredProceduresSpServiceAgreementsRemoveContactParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_RemoveContact`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsRemoveContactQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsRemoveContactParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_RemoveContact`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsRemoveContactQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsRemoveContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsRemoveContactQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsRemoveContact(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsRemoveContactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>>
export type GetApiStoredProceduresSpServiceAgreementsRemoveContactQueryError = ErrorType<void>


/**
 * @summary Removes a contact from a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsRemoveContact<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsRemoveContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsRemoveContactQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Removes a credit control hold from a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold = (
    params: GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_RemoveCreditControlHold`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_RemoveCreditControlHold`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>>
export type GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryError = ErrorType<void>


/**
 * @summary Removes a credit control hold from a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRemoveCreditControlHold>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsRemoveCreditControlHoldQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Retries failed subscription reviews for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews = (
    params: GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_RetryFailedSubscriptionReviews`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_RetryFailedSubscriptionReviews`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>>
export type GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryError = ErrorType<void>


/**
 * @summary Retries failed subscription reviews for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsRetryFailedSubscriptionReviewsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends an email to a customer.
 */
export const postApiStoredProceduresSpServiceAgreementsSendCustomerEmail = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SendCustomerEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSendCustomerEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSendCustomerEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSendCustomerEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSendCustomerEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>>
    export type PostApiStoredProceduresSpServiceAgreementsSendCustomerEmailMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSendCustomerEmailMutationError = ErrorType<void>

    /**
 * @summary Sends an email to a customer.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSendCustomerEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSendCustomerEmail>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSendCustomerEmailRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSendCustomerEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sends an email to a customer requesting repayment of a discount.
 */
export const getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail = (
    params: GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SendDiscountRepaymentEmail`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SendDiscountRepaymentEmail`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>>
export type GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryError = ErrorType<void>


/**
 * @summary Sends an email to a customer requesting repayment of a discount.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSendDiscountRepaymentEmailQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends a feedback request to a customer.
 */
export const getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest = (
    params: GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SendFeedbackRequest`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SendFeedbackRequest`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>>
export type GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryError = ErrorType<void>


/**
 * @summary Sends a feedback request to a customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSendFeedbackRequest<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendFeedbackRequest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSendFeedbackRequestQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends an initial sales email to a customer.
 */
export const getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail = (
    params: GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SendInitialSalesEmail`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SendInitialSalesEmail`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>>
export type GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryError = ErrorType<void>


/**
 * @summary Sends an initial sales email to a customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendInitialSalesEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSendInitialSalesEmailQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sends a retention email to a customer.
 */
export const getApiStoredProceduresSpServiceAgreementsSendRetentionEmail = (
    params: GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SendRetentionEmail`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SendRetentionEmail`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSendRetentionEmail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>>
export type GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryError = ErrorType<void>


/**
 * @summary Sends a retention email to a customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSendRetentionEmail<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSendRetentionEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSendRetentionEmail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSendRetentionEmailQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Marks a service agreement as superseded by another service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded = (
    params: GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ServiceAgreementSuperseded`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_ServiceAgreementSuperseded`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>>
export type GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryError = ErrorType<void>


/**
 * @summary Marks a service agreement as superseded by another service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsServiceAgreementSuperseded>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsServiceAgreementSupersededQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the activation reason for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetActivationReason = (
    params: GetApiStoredProceduresSpServiceAgreementsSetActivationReasonParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetActivationReason`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetActivationReasonParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetActivationReason`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetActivationReasonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetActivationReason(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>>
export type GetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryError = ErrorType<void>


/**
 * @summary Sets the activation reason for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetActivationReason<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetActivationReasonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetActivationReason>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetActivationReasonQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the address for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetAddress = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetAddress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetAddressMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetAddress(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetAddressMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetAddressMutationError = ErrorType<void>

    /**
 * @summary Sets the address for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetAddress = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetAddress>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetAddressRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetAddressMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets an audit record for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetAudit = (
    params: GetApiStoredProceduresSpServiceAgreementsSetAuditParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetAudit`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetAuditQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetAuditParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetAudit`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetAuditQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetAuditQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetAudit(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>>
export type GetApiStoredProceduresSpServiceAgreementsSetAuditQueryError = ErrorType<void>


/**
 * @summary Sets an audit record for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetAudit<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetAudit>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetAuditQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the boiler details for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetBoilerDetails = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetBoilerDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetBoilerDetailsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetBoilerDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetBoilerDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetBoilerDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetBoilerDetailsMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetBoilerDetailsMutationError = ErrorType<void>

    /**
 * @summary Sets the boiler details for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetBoilerDetails = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetBoilerDetails>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetBoilerDetailsRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetBoilerDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the cancellation notes for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCancellationNotes = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCancellationNotes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCancellationNotes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCancellationNotes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryError = ErrorType<void>


/**
 * @summary Sets the cancellation notes for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCancellationNotes<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCancellationNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancellationNotes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCancellationNotesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the cancel reason data for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCancelReasonData = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCancelReasonData`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCancelReasonData`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCancelReasonData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryError = ErrorType<void>


/**
 * @summary Sets the cancel reason data for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCancelReasonData<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCancelReasonData>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCancelReasonDataQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the claim validation context snapshot for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetClaimValidationContextSnapshot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotMutationError = ErrorType<void>

    /**
 * @summary Sets the claim validation context snapshot for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshot>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetClaimValidationContextSnapshotMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the claim validation for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetClaimValidation = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetClaimValidation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetClaimValidationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetClaimValidation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetClaimValidation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetClaimValidationMutationError = ErrorType<void>

    /**
 * @summary Sets the claim validation for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetClaimValidation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetClaimValidation>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetClaimValidationRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetClaimValidationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the contact for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetContact = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetContact(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetContactMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetContactMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetContactMutationError = ErrorType<void>

    /**
 * @summary Sets the contact for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetContact>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetContactRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the credit control action log for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCreditControlActionLogResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCreditControlActionLog`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCreditControlActionLog`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryError = ErrorType<void>


/**
 * @summary Sets the credit control action log for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlActionLog>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCreditControlActionLogQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the credit control for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCreditControl = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCreditControlResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCreditControl`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCreditControl`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCreditControl(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryError = ErrorType<void>


/**
 * @summary Sets the credit control for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCreditControl<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControl>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCreditControlQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets a credit control hold for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCreditControlHold = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCreditControlHold`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCreditControlHold`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCreditControlHold(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryError = ErrorType<void>


/**
 * @summary Sets a credit control hold for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCreditControlHold<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCreditControlHold>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCreditControlHoldQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the customer for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetCustomer = (
    params: GetApiStoredProceduresSpServiceAgreementsSetCustomerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetCustomer`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetCustomerQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetCustomerParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetCustomer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetCustomer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>>
export type GetApiStoredProceduresSpServiceAgreementsSetCustomerQueryError = ErrorType<void>


/**
 * @summary Sets the customer for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetCustomer<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the diary for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetDiary = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetDiary`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetDiaryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetDiary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetDiary(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetDiaryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetDiaryMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetDiaryMutationError = ErrorType<void>

    /**
 * @summary Sets the diary for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetDiary = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetDiary>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetDiaryRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetDiaryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets an enquiry for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetEnquiry = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetEnquiry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetEnquiryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetEnquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetEnquiry(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetEnquiryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetEnquiryMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetEnquiryMutationError = ErrorType<void>

    /**
 * @summary Sets an enquiry for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetEnquiry = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetEnquiry>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetEnquiryRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetEnquiryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets an external engineer for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetExternalEngineer = (
    params: GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetExternalEngineer`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetExternalEngineer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetExternalEngineer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>>
export type GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryError = ErrorType<void>


/**
 * @summary Sets an external engineer for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetExternalEngineer<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetExternalEngineerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetExternalEngineer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetExternalEngineerQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets a job for a service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetJob = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetJobMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetJobMutationError = ErrorType<void>

    /**
 * @summary Sets a job for a service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetJob>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetJobRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets a login for a customer.
 */
export const getApiStoredProceduresSpServiceAgreementsSetLogin = (
    params: GetApiStoredProceduresSpServiceAgreementsSetLoginParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetLogin`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetLoginQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetLoginParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetLogin`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetLoginQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetLoginQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetLogin(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>>
export type GetApiStoredProceduresSpServiceAgreementsSetLoginQueryError = ErrorType<void>


/**
 * @summary Sets a login for a customer.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetLogin<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetLogin>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetLoginQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets a note for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetNote = (
    params: GetApiStoredProceduresSpServiceAgreementsSetNoteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetNoteResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetNote`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetNoteQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetNoteParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetNote`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetNoteQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetNoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetNoteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetNote(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>>
export type GetApiStoredProceduresSpServiceAgreementsSetNoteQueryError = ErrorType<void>


/**
 * @summary Sets a note for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetNote<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetNoteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetNote>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetNoteQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the payment for a service agreement
 */
export const postApiStoredProceduresSpServiceAgreementsSetPayment = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetPayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetPaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetPayment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetPaymentMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetPaymentMutationError = ErrorType<void>

    /**
 * @summary Sets the payment for a service agreement
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetPayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetPayment>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetPaymentRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetPaymentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the payment details status for a service agreement or a specific payment details item
 */
export const getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus = (
    params: GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetPaymentDetailsStatus`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetPaymentDetailsStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>>
export type GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryError = ErrorType<void>


/**
 * @summary Sets the payment details status for a service agreement or a specific payment details item
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetPaymentDetailsStatusQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Set a refund for a payment made on a service agreement
 */
export const postApiStoredProceduresSpServiceAgreementsSetRefund = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetRefund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetRefundMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetRefund(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetRefundMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetRefundMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>
    export type PostApiStoredProceduresSpServiceAgreementsSetRefundMutationError = ErrorType<void>

    /**
 * @summary Set a refund for a payment made on a service agreement
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetRefund = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetRefund>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetRefundRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetRefundMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates a new service agreement.
 */
export const postApiStoredProceduresSpServiceAgreementsSetServiceAgreement = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Result>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetServiceAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsSetServiceAgreementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsSetServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsSetServiceAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsSetServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>>
    export type PostApiStoredProceduresSpServiceAgreementsSetServiceAgreementMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>
    export type PostApiStoredProceduresSpServiceAgreementsSetServiceAgreementMutationError = ErrorType<void>

    /**
 * @summary Creates a new service agreement.
 */
export const usePostApiStoredProceduresSpServiceAgreementsSetServiceAgreement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsSetServiceAgreement>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetServiceAgreementV5Request>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsSetServiceAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Sets the Stripe payment details for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetStripePaymentDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetStripePaymentDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryError = ErrorType<void>


/**
 * @summary Sets the Stripe payment details for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetStripePaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetStripePaymentDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets the VIP override status for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsSetVIPOverride = (
    params: GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_SetVIPOverride`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_SetVIPOverride`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsSetVIPOverride(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>>
export type GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryError = ErrorType<void>


/**
 * @summary Sets the VIP override status for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsSetVIPOverride<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsSetVIPOverrideParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsSetVIPOverride>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsSetVIPOverrideQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Stops the cancellation process for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsStopCancellation = (
    params: GetApiStoredProceduresSpServiceAgreementsStopCancellationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_StopCancellation`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsStopCancellationQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsStopCancellationParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_StopCancellation`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsStopCancellationQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsStopCancellationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsStopCancellationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsStopCancellation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsStopCancellationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>>
export type GetApiStoredProceduresSpServiceAgreementsStopCancellationQueryError = ErrorType<void>


/**
 * @summary Stops the cancellation process for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsStopCancellation<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsStopCancellationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsStopCancellation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsStopCancellationQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Enables or disables an allocated subscription offer for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer = (
    params: GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ToggleAllocatedSubscriptionOffer`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_ToggleAllocatedSubscriptionOffer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>>
export type GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryError = ErrorType<void>


/**
 * @summary Enables or disables an allocated subscription offer for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOffer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsToggleAllocatedSubscriptionOfferQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Undoes the cancellation of a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsUndoCancellation = (
    params: GetApiStoredProceduresSpServiceAgreementsUndoCancellationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_UndoCancellation`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsUndoCancellationParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_UndoCancellation`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsUndoCancellationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsUndoCancellation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>>
export type GetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryError = ErrorType<void>


/**
 * @summary Undoes the cancellation of a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsUndoCancellation<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsUndoCancellationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUndoCancellation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsUndoCancellationQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Updates the payment details for a service agreement.
 */
export const getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails = (
    params: GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_UpdateServiceAgreementPaymentDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryKey = (params: GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsParams,) => {
    return [`/api/StoredProcedures/sp_ServiceAgreements_UpdateServiceAgreementPaymentDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>> = ({ signal }) => getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>>
export type GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryError = ErrorType<void>


/**
 * @summary Updates the payment details for a service agreement.
 */

export function useGetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpServiceAgreementsUpdateServiceAgreementPaymentDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Validates a campaign code.
 */
export const postApiStoredProceduresSpServiceAgreementsValidateCampaignCode = (
    careClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeResult>(
      {url: `/api/StoredProcedures/sp_ServiceAgreements_ValidateCampaignCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpServiceAgreementsValidateCampaignCodeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpServiceAgreementsValidateCampaignCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpServiceAgreementsValidateCampaignCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpServiceAgreementsValidateCampaignCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>>
    export type PostApiStoredProceduresSpServiceAgreementsValidateCampaignCodeMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>
    export type PostApiStoredProceduresSpServiceAgreementsValidateCampaignCodeMutationError = ErrorType<void>

    /**
 * @summary Validates a campaign code.
 */
export const usePostApiStoredProceduresSpServiceAgreementsValidateCampaignCode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpServiceAgreementsValidateCampaignCode>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsValidateCampaignCodeRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpServiceAgreementsValidateCampaignCodeMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets the value of a setting.
 */
export const getApiStoredProceduresSpSettingsGetSetting = (
    params?: GetApiStoredProceduresSpSettingsGetSettingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpSettingsGetSettingResult>(
      {url: `/api/StoredProcedures/sp_Settings_GetSetting`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpSettingsGetSettingQueryKey = (params?: GetApiStoredProceduresSpSettingsGetSettingParams,) => {
    return [`/api/StoredProcedures/sp_Settings_GetSetting`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpSettingsGetSettingQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>, TError = ErrorType<void>>(params?: GetApiStoredProceduresSpSettingsGetSettingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpSettingsGetSettingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>> = ({ signal }) => getApiStoredProceduresSpSettingsGetSetting(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpSettingsGetSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>>
export type GetApiStoredProceduresSpSettingsGetSettingQueryError = ErrorType<void>


/**
 * @summary Gets the value of a setting.
 */

export function useGetApiStoredProceduresSpSettingsGetSetting<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>, TError = ErrorType<void>>(
 params?: GetApiStoredProceduresSpSettingsGetSettingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpSettingsGetSetting>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpSettingsGetSettingQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the Stripe customer associated with a service agreement from the database.
 */
export const getApiStoredProceduresSpStripeGetCustomer = (
    params: GetApiStoredProceduresSpStripeGetCustomerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeGetCustomerResult[]>(
      {url: `/api/StoredProcedures/sp_Stripe_GetCustomer`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpStripeGetCustomerQueryKey = (params: GetApiStoredProceduresSpStripeGetCustomerParams,) => {
    return [`/api/StoredProcedures/sp_Stripe_GetCustomer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpStripeGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpStripeGetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpStripeGetCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>> = ({ signal }) => getApiStoredProceduresSpStripeGetCustomer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpStripeGetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>>
export type GetApiStoredProceduresSpStripeGetCustomerQueryError = ErrorType<void>


/**
 * @summary Gets the Stripe customer associated with a service agreement from the database.
 */

export function useGetApiStoredProceduresSpStripeGetCustomer<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpStripeGetCustomerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeGetCustomer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpStripeGetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Sets a card for a customer in Stripe in the database.
 */
export const getApiStoredProceduresSpStripeSetCard = (
    params: GetApiStoredProceduresSpStripeSetCardParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetCardResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetCard`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpStripeSetCardQueryKey = (params: GetApiStoredProceduresSpStripeSetCardParams,) => {
    return [`/api/StoredProcedures/sp_Stripe_SetCard`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpStripeSetCardQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpStripeSetCardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpStripeSetCardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>> = ({ signal }) => getApiStoredProceduresSpStripeSetCard(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpStripeSetCardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>>
export type GetApiStoredProceduresSpStripeSetCardQueryError = ErrorType<void>


/**
 * @summary Sets a card for a customer in Stripe in the database.
 */

export function useGetApiStoredProceduresSpStripeSetCard<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpStripeSetCardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetCard>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpStripeSetCardQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Creates a charge in Stripe table.
 */
export const postApiStoredProceduresSpStripeSetCharge = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetCharge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetChargeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetCharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetCharge(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetChargeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>>
    export type PostApiStoredProceduresSpStripeSetChargeMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>
    export type PostApiStoredProceduresSpStripeSetChargeMutationError = ErrorType<void>

    /**
 * @summary Creates a charge in Stripe table.
 */
export const usePostApiStoredProceduresSpStripeSetCharge = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCharge>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetChargeRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetChargeMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates or updates a coupon in Stripe table.
 */
export const postApiStoredProceduresSpStripeSetCoupon = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetCoupon`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetCouponMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetCoupon(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetCouponMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>>
    export type PostApiStoredProceduresSpStripeSetCouponMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>
    export type PostApiStoredProceduresSpStripeSetCouponMutationError = ErrorType<void>

    /**
 * @summary Creates or updates a coupon in Stripe table.
 */
export const usePostApiStoredProceduresSpStripeSetCoupon = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCoupon>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCouponRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetCouponMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates or updates a customer in Stripe table.
 */
export const postApiStoredProceduresSpStripeSetCustomer = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetCustomer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetCustomerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetCustomer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>>
    export type PostApiStoredProceduresSpStripeSetCustomerMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>
    export type PostApiStoredProceduresSpStripeSetCustomerMutationError = ErrorType<void>

    /**
 * @summary Creates or updates a customer in Stripe table.
 */
export const usePostApiStoredProceduresSpStripeSetCustomer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetCustomer>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetCustomerRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetCustomerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Stores a Stripe event in the database.
 */
export const postApiStoredProceduresSpStripeSetEvent = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetEvent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetEvent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetEventMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>>
    export type PostApiStoredProceduresSpStripeSetEventMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>
    export type PostApiStoredProceduresSpStripeSetEventMutationError = ErrorType<void>

    /**
 * @summary Stores a Stripe event in the database.
 */
export const usePostApiStoredProceduresSpStripeSetEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetEvent>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Updates the processed and ignored status of a Stripe event in the database.
 */
export const getApiStoredProceduresSpStripeSetEventStatus = (
    params: GetApiStoredProceduresSpStripeSetEventStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetEventStatusResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetEventStatus`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiStoredProceduresSpStripeSetEventStatusQueryKey = (params: GetApiStoredProceduresSpStripeSetEventStatusParams,) => {
    return [`/api/StoredProcedures/sp_Stripe_SetEventStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiStoredProceduresSpStripeSetEventStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>, TError = ErrorType<void>>(params: GetApiStoredProceduresSpStripeSetEventStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoredProceduresSpStripeSetEventStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>> = ({ signal }) => getApiStoredProceduresSpStripeSetEventStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStoredProceduresSpStripeSetEventStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>>
export type GetApiStoredProceduresSpStripeSetEventStatusQueryError = ErrorType<void>


/**
 * @summary Updates the processed and ignored status of a Stripe event in the database.
 */

export function useGetApiStoredProceduresSpStripeSetEventStatus<TData = Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>, TError = ErrorType<void>>(
 params: GetApiStoredProceduresSpStripeSetEventStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStoredProceduresSpStripeSetEventStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiStoredProceduresSpStripeSetEventStatusQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Creates a Stripe payment intent in the database.
 */
export const postApiStoredProceduresSpStripeSetPaymentIntent = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetPaymentIntent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetPaymentIntentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetPaymentIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetPaymentIntent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetPaymentIntentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>>
    export type PostApiStoredProceduresSpStripeSetPaymentIntentMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>
    export type PostApiStoredProceduresSpStripeSetPaymentIntentMutationError = ErrorType<void>

    /**
 * @summary Creates a Stripe payment intent in the database.
 */
export const usePostApiStoredProceduresSpStripeSetPaymentIntent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPaymentIntent>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPaymentIntentRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetPaymentIntentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates a Stripe plan in the database.
 */
export const postApiStoredProceduresSpStripeSetPlan = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetPlan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetPlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetPlan(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetPlanMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>>
    export type PostApiStoredProceduresSpStripeSetPlanMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>
    export type PostApiStoredProceduresSpStripeSetPlanMutationError = ErrorType<void>

    /**
 * @summary Creates a Stripe plan in the database.
 */
export const usePostApiStoredProceduresSpStripeSetPlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetPlan>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetPlanRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetPlanMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates a Stripe product in the database.
 */
export const postApiStoredProceduresSpStripeSetProduct = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetProduct`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetProductMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetProduct(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetProductMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>>
    export type PostApiStoredProceduresSpStripeSetProductMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>
    export type PostApiStoredProceduresSpStripeSetProductMutationError = ErrorType<void>

    /**
 * @summary Creates a Stripe product in the database.
 */
export const usePostApiStoredProceduresSpStripeSetProduct = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetProduct>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetProductRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetProductMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates a Stripe refund in the database.
 */
export const postApiStoredProceduresSpStripeSetRefund = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetRefund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetRefundMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetRefund(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetRefundMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>>
    export type PostApiStoredProceduresSpStripeSetRefundMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>
    export type PostApiStoredProceduresSpStripeSetRefundMutationError = ErrorType<void>

    /**
 * @summary Creates a Stripe refund in the database.
 */
export const usePostApiStoredProceduresSpStripeSetRefund = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetRefund>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetRefundRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetRefundMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates or updates Stripe data for all service agreements in the database matching the specified service agreement customer ID.
 */
export const postApiStoredProceduresSpStripeSetServiceAgreement = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/StoredProcedures/sp_Stripe_SetServiceAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetServiceAgreementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetServiceAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>>
    export type PostApiStoredProceduresSpStripeSetServiceAgreementMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>
    export type PostApiStoredProceduresSpStripeSetServiceAgreementMutationError = ErrorType<void>

    /**
 * @summary Creates or updates Stripe data for all service agreements in the database matching the specified service agreement customer ID.
 */
export const usePostApiStoredProceduresSpStripeSetServiceAgreement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetServiceAgreement>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetServiceAgreementRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetServiceAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates or updates a Stripe subscription in the database.
 */
export const postApiStoredProceduresSpStripeSetSubscription = (
    careClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>, {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>>
    export type PostApiStoredProceduresSpStripeSetSubscriptionMutationBody = BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>
    export type PostApiStoredProceduresSpStripeSetSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Creates or updates a Stripe subscription in the database.
 */
export const usePostApiStoredProceduresSpStripeSetSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>, TError,{data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscription>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetSubscriptionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Creates or updates a Stripe subscription in the database.
 */
export const postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription = (
    rightioStripeAPIWrapperModelsDtoSubscriptionDto: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpStripeSetSubscriptionResult>(
      {url: `/api/StoredProcedures/sp_Stripe_SetSubscription/Sp_Stripe_SetSubscriptionFromSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioStripeAPIWrapperModelsDtoSubscriptionDto, signal
    },
      options);
    }
  


export const getPostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>, TError,{data: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>, TError,{data: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>}, TContext> => {

const mutationKey = ['postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>, {data: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>>
    export type PostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscriptionMutationBody = BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>
    export type PostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Creates or updates a Stripe subscription in the database.
 */
export const usePostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>, TError,{data: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscription>>,
        TError,
        {data: BodyType<RightioStripeAPIWrapperModelsDtoSubscriptionDto>},
        TContext
      > => {

      const mutationOptions = getPostApiStoredProceduresSpStripeSetSubscriptionSpStripeSetSubscriptionFromSubscriptionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    